'use client'

import { useEffect, useState } from 'react'

import { isVisionLocal } from '@common/core/utils/isVisionLocal'

import { getBrowserHostname } from '@/core/utils/getBrowserHostname'
import { isLocalHostname } from '@/core/utils/isLocalHostname'

export function useIsLocalGatewayConfigurationMode(): boolean {
  const envMode = isVisionLocal() || !process.env.NEXT_PUBLIC_GATEWAY_URL?.trim()
  const [hostnameMode, setHostnameMode] = useState(false)

  useEffect(() => {
    if (!envMode) {
      const hostname = getBrowserHostname()
      setHostnameMode(Boolean(hostname && isLocalHostname(hostname)))
    }
  }, [envMode])

  return envMode || hostnameMode
}
